// extracted by mini-css-extract-plugin
export var mainContent = "h_D";
export var mainContentWithGlobal = "h_F";
export var rootPath = "h_C";
export var skeletonMenuContainer = "h_G";
export var skeletonRow = "h_H";